/**
 * @ngdoc Controller
 */
import { handleFileDownload } from "@/utils/download";
import {vrmConfig} from '@/config';
import {urlEncodeArray} from "@/utils/url";

(function () {
    'use strict';

    angular.module('vrm.components')
        .controller('DownloadPrductionReportModalController', DownloadPrductionReportModalController);

    /* @ngInject */
    function DownloadPrductionReportModalController($scope, allSiteIds, filteredSiteIds, $log, locale, close, $filter, ApiService, AdvancedGraphWidgetConfigs, widgetTypeMapping, VrmModalService, $timeout, vrmNotificationsService, vrmNotificationType) {
        locale.ready('datepicker').then(function () {
            var downloadPending = false;

            // maxDate is also used in the rest of the controller as being "now", instead of using new Date()
            var maxDate = new Date();

            // Create the lowest selectable date to be 180 days ago.
            var minDate = new Date(maxDate.getTime());
            minDate.setDate(minDate.getDate() - 180);

            var initFromDate = new Date(maxDate.getFullYear(), maxDate.getMonth(), 1);
            var initTillDate = new Date(maxDate.getTime());

            var monthNamesFull = [
                locale.getString('datepicker.january'),
                locale.getString('datepicker.februari'),
                locale.getString('datepicker.march'),
                locale.getString('datepicker.april'),
                locale.getString('datepicker.may'),
                locale.getString('datepicker.juni'),
                locale.getString('datepicker.july'),
                locale.getString('datepicker.august'),
                locale.getString('datepicker.september'),
                locale.getString('datepicker.october'),
                locale.getString('datepicker.november'),
                locale.getString('datepicker.december')
            ];

            $scope.filtersEnabled = filteredSiteIds && filteredSiteIds.length && allSiteIds.length !== filteredSiteIds.length;
            $scope.downloadForAllSites = {
                value: false,
            }
            $scope.monthObjs = createMonthObjs();
            $scope.selectedMonthObj = { value: null };
            $scope.picker = {
                fromMinDate: minDate,
                fromMaxDate: maxDate,
                tillMinDate: minDate,
                tillMaxDate: maxDate,
                from: initFromDate,
                till: initTillDate
            };
            $scope.submitted = false;
            $scope.notSelectedTimezoneError = false;


            $scope.pickadata = {
                dateOptions: {
                    clear: false,
                    monthsFull: monthNamesFull,
                    weekdaysShort: [
                        locale.getString('datepicker.short_sunday'),
                        locale.getString('datepicker.short_monday'),
                        locale.getString('datepicker.short_tuesday'),
                        locale.getString('datepicker.short_wednesday'),
                        locale.getString('datepicker.short_thursday'),
                        locale.getString('datepicker.short_friday'),
                        locale.getString('datepicker.short_saturday')
                    ],
                    today: locale.getString('datepicker.today'),
                    close: locale.getString('datepicker.close'),
                    format: locale.getString('datepicker.format'),
                    onSet: function(context) {
                        if(context.select) {
                            if($scope.selectedMonthObj.value) {
                                // if from/till is set after a month was selected this makes sure the till/from (the other one) is set to the start or end of the month
                                if(!$scope.picker.from) {
                                    $scope.picker.from = new Date($scope.picker.till.getFullYear(), $scope.picker.till.getMonth(), 1);
                                }
                                if(!$scope.picker.till) {
                                    $scope.picker.till = new Date($scope.picker.from.getFullYear(), $scope.picker.from.getMonth()+1, 0);
                                }
                            }

                            $scope.selectedMonthObj.value = null;

                            if($scope.picker.till && $scope.picker.fromMaxDate.getTime() != $scope.picker.till.getTime()) {
                                // update the fromMaxDate according to be the same as the till date so that from can't be higher than till
                                $scope.picker.fromMaxDate = new Date($scope.picker.till);
                            }

                            if($scope.picker.from && $scope.picker.tillMinDate.getTime() != $scope.picker.from.getTime()) {
                                // update the tillMinDate to be the same as the from date so that it can't be lower than from
                                $scope.picker.tillMinDate = new Date($scope.picker.from);
                            }
                        }
                    }
                },
                timeOptions: {
                    clear: false,
                    format: 'HH:i'
                }
            };

            $scope.setMonth = function(monthObj) {
                // null/reset the from/till date pickers
                $scope.picker.from = null;
                $scope.picker.till = null;
                $scope.picker.fromMaxDate = maxDate;
                $scope.picker.tillMinDate = minDate;

                $timeout(function() {
                    //the picker's onSet callback resets the input. Here we set it back again.
                    $scope.selectedMonthObj.value = monthObj;
                });
            };

            $scope.downloadReport = function() {
                $scope.submitted = true;
                if($scope.timezone.selected){
                    VrmModalService.closeActiveModal();

                    if (downloadPending) {
                        locale.ready('installationoverview').then(function () {
                            vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('installationoverview.download_pending') });
                        });
                        return;
                    }

                    var range = getRange();
                    var from = range['from'];
                    var till = range['till'];

                    VrmModalService.openDownloadModal($scope, 'installationoverview.preparing_download');

                    downloadPending = true;

                    ApiService.download(vrmConfig.reportUrl, buildRequestData(), true, 'POST')
                        .then(function(response) {
                            //why do we move into timezone when getting the response
                            const timezone = $scope.timezone.selected ? $scope.timezone.selected.abbr : null;

                            //adjust From/Till for response in the saving file
                            handleFileDownload(
                                response.data,
                                `vrm_production_report_${formatDateUser(from)}_${formatDateUser(till)}_${timezone}.xlsx`
                            );

                            // saveAs(response.data, 'vrm_production_report_' + $filter('date')(tzFrom, "ddMMyy") + '-' + $filter('date')(tzTill, "ddMMyy") + '.xlsx');
                            downloadPending = false;
                            $.magnificPopup.close();
                        }, function() {
                            locale.ready('installationoverview').then(function () {
                                vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('installationoverview.download_failed') , timeout: 30000});
                            });
                            downloadPending = false;
                            $.magnificPopup.close();
                        });
                }
                else{
                    $scope.notSelectedTimezoneError = true;
                }
            };

            function createMonthObjs() {
                var objs = [];

                for(var i = 0; i < monthNamesFull.length; i++) {
                    objs.push({
                       'monthName': monthNamesFull[i],
                       'monthIndex': i,
                       'year': getLastYearOccurence(i),
                       'postString': '',
                       'from': getMonthStartDate(getLastYearOccurence(i), i),
                       'to': getMonthEndDate(getLastYearOccurence(i), i)
                    });
                }
                objs.sort(function(a, b) {
                    a = a.from;
                    b = b.from;
                    return a>b ? -1 : a<b ? 1 : 0;
                });

                objs.splice(7, 100); // Remove the remaining months from the array, so we end up with 7 months
                // add text saying that data is available from minDate for this month
                objs[objs.length-1].postString = "(" + locale.getString('installationoverview.starting_from') + ': ' + $filter('date')(minDate, "yyyy-MM-dd") + ')';
                objs[objs.length-1].from = minDate;
                return objs;
            }

            function getLastYearOccurence(monthIndex) {
                var currentMonthIndex = maxDate.getMonth();
                var currentYear = maxDate.getFullYear();
                return monthIndex <= currentMonthIndex ? currentYear : currentYear - 1;
            }

            function getMonthStartDate(year, monthIndex) {
                var date = new Date(year, monthIndex);
                var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                return firstDay;
            }

            function getMonthEndDate(year, monthIndex) {
                if(isCurrentMonth(year, monthIndex)) {
                    return maxDate;
                } else {
                    var date = new Date(year, monthIndex);
                    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    return lastDay;
                }
            }

            function isCurrentMonth(year, monthIndex) {
                return maxDate.getMonth() === monthIndex && maxDate.getFullYear() === year;
            }

            function getRange() {
                var from = $scope.picker.from;
                var till = $scope.picker.till;

                // if the month is set then use that for from and till
                // if from till or both are empty set defaults.
                if($scope.selectedMonthObj.value) {
                    from = $scope.selectedMonthObj.value.from;
                    till = $scope.selectedMonthObj.value.to;
                } else if (!from && !till) {
                    from = initFromDate;
                    till = initTillDate;
                } else if (!from) {
                    from = new Date(till.getFullYear(), till.getMonth(), 1);
                } else if (!till) {
                    till = new Date(from.getFullYear(), from.getMonth()+1, 0);
                }

                return {'from': from, 'till': till};
            }

            function formatDateUser(dateObj, timezone){
                // month  + 1 as javascript starts counting months from 0
                return  `${dateObj.getFullYear()}/${dateObj.getMonth() + 1}/${dateObj.getDate()}`
            }

            function buildRequestData() {
                // declare from/till and assign the time range to it
                const range = getRange();
                const from = range['from'];
                const till = range['till'];
                const timezone = $scope.timezone.selected ? $scope.timezone.selected.abbr : null; // if passing null return error from backend (chose a timezone)

                const data = {
                    'start': makeDate(Date.UTC(from.getFullYear(), from.getMonth(), from.getDate(), 0, 0, 0)),
                    'end': makeDate(Date.UTC(till.getFullYear(), till.getMonth(), till.getDate(), 23, 59, 59)),
                }
                if (timezone) {
                    data['timezone'] = timezone;
                }
                if ($scope.filtersEnabled && !$scope.downloadForAllSites.value) {
                    data['siteIds'] = filteredSiteIds;
                }

                return data;
            }

            function makeDate(timestamp) {
                return Math.round(timestamp / 1000);
            }

            $scope.timezone = {
                selected: null,
                options: [],
            };

            const timezonesDict = {
                "akdt": "America/Anchorage",
                "cdt": "America/Chicago",
                "mdt": "America/Denver",
                "adt": "America/Halifax",
                "pdt": "America/Los_Angeles",
                "est": "America/New_York",
                "wib": "Asia/Jakarta",
                "pkt": "Asia/Karachi",
                "awst": "Asia/Shanghai",
                "jst": "Asia/Tokyo",
                "aest": "Australia/Melbourne",
                "gmt": "Etc/Greenwich",
                "msk": "Europe/Moscow",
                "cet": "Europe/Paris",
                "nzdt": "Pacific/Auckland",
                "hst": "Pacific/Honolulu"
            }

            // todo filter them in alphabetical order
            // filling options with abbreviations now
            // make timezone name the key
            // fix frontend time being saved a day eralier (6 - 6 should be same as in the report)
            for (const [abbr, timezoneName] of Object.entries(timezonesDict)) {
                $scope.timezone.options.push({
                    timezoneName,
                    abbr,
                    isLocal: false,
                });
            }

            var offsetUTC = Math.round(new Date().getTimezoneOffset() * ( -1 ) / 60);
            const prefix = vrmConfig.reportApiDomain;
            let url = `https://${prefix}/timezone/local?offset=${offsetUTC}`;

            //get local timezone based on timestamp to set default value
            ApiService.call2(url, null, {method:'GET'})
                .then(function(response) {
                    const timezoneAbbr = response.data.abbreviation; // set null by default

                    for(const key in $scope.timezone.options){
                        const value = $scope.timezone.options[key];
                        if (value.abbr === timezoneAbbr ){
                            $scope.timezone.selected = value;
                        }
                    }
                }, function() {
                    locale.ready('installationoverview').then(function () {
                        vrmNotificationsService.add( {type: vrmNotificationType.ERROR, message: locale.getString('installationoverview.download_failed') , timeout: 30000});
                    });
                    downloadPending = false;
                    $.magnificPopup.close();
                });

        });

        return {
            close: close
        };
    }

})();
